import {
	SET_MY_USER_PROFILE,
	SET_USER_PROFILE,
	SET_GROUP_PROFILE,
	SET_ORGANISATION_PROFILE,
	ADD_USER_TO_GROUP,
	REMOVE_USER_FROM_GROUP,
	SET_USER_GROUP_ROLE,
	SET_CITIZEN_PROFILE,
	UPDATE_USER_REPLACEMENTS,
	UPDATE_USER_REPLACEMENTS_SUCCESS,
	UPDATE_USER_REPLACEMENTS_ERROR,
	UPDATE_USER_NOTIFICATION_SETTINGS,
	UPDATE_USER_NOTIFICATION_SETTINGS_SUCCESS,
	UPDATE_USER_NOTIFICATION_SETTINGS_ERROR,
	UPDATE_USER_DATA,
	UPDATE_USER_DATA_SUCCESS,
	UPDATE_USER_DATA_ERROR,
	UPDATE_USER_ASSIGNMENT_OPTIONS,
	UPDATE_USER_ASSIGNMENT_OPTIONS_SUCCESS,
	UPDATE_USER_ASSIGNMENT_OPTIONS_ERROR,
	UPDATE_ORGANISATION_RESPONSIBILITIES_SUCCESS,
	UPDATE_ORGANISATION_RESPONSIBILITIES_ERROR,
	UPDATE_ORGANISATION_APP_USER_CONNECTIONS,
	UPDATE_USER_SETTINGS,
	UPDATE_GROUP_SETTINGS,
	UPDATE_ORGANISATION_CONTACTS,
	SERVER_GET_USER_PROFILE,
	SERVER_GET_GROUP_PROFILE,
	SERVER_GET_ORGANISATION_PROFILE,
	SERVER_ADD_USER_TO_GROUP,
	SERVER_REMOVE_USER_FROM_GROUP,
	SERVER_SET_USER_GROUP_ROLE,
	SERVER_CREATE_NEW_USER,
	SERVER_CREATE_NEW_GROUP,
	SERVER_UPDATE_ORGANISATION_GROUP_STRUCTURE,
	SERVER_UPDATE_ORGANISATION_DATA,
	SERVER_UPDATE_GROUP_DATA,
	SERVER_UPDATE_USER_DATA,
	SERVER_GET_CITIZEN_PROFILE,
	SERVER_UPDATE_CITIZEN_DATA,
	SERVER_UPDATE_USER_REPLACEMENTS,
	SERVER_UPDATE_USER_NOTIFICATION_SETTINGS,
	SERVER_UPDATE_USER_ASSIGNMENT_OPTIONS,
	SERVER_UPDATE_ORGANISATION_RESPONSIBILITIES,
	SERVER_UPDATE_ORGANISATION_SETTINGS,
	SERVER_UPDATE_ORGANISATION_MELDOO_APP_SETTINGS,
	SERVER_UPDATE_ORGANISATION_MELDOO_WEB_SETTINGS,
	SERVER_ADD_ORGANISATION_APP_USER_CONNECTION,
	SERVER_REMOVE_ORGANISATION_APP_USER_CONNECTION,
	SERVER_UPDATE_USER_SETTINGS,
	SERVER_UPDATE_GROUP_SETTINGS,
	SERVER_REPORT_CITIZEN,
	SERVER_ADD_ORGANISATION_CONTACT,
	SERVER_UPDATE_ORGANISATION_CONTACT,
	SERVER_DELETE_ORGANISATION_CONTACT,
	REPORT_CITIZEN_SUCCESS,
	REPORT_CITIZEN_ERROR,
	UPDATE_ORGANISATION_SETTINGS_SUCCESS,
	UPDATE_ORGANISATION_SETTINGS_ERROR,
	UPDATE_ORGANISATION_MELDOO_APP_SETTINGS_SUCCESS,
	UPDATE_ORGANISATION_MELDOO_APP_SETTINGS_ERROR,
	UPDATE_ORGANISATION_MELDOO_WEB_SETTINGS_SUCCESS,
	UPDATE_ORGANISATION_MELDOO_WEB_SETTINGS_ERROR,
	ADD_ORGANISATION_APP_USER_CONNECTION_SUCCESS,
	ADD_ORGANISATION_APP_USER_CONNECTION_ERROR,
	REMOVE_ORGANISATION_APP_USER_CONNECTION_ERROR,
	ADD_ORGANISATION_CONTACT_ERROR,
	UPDATE_ORGANISATION_CONTACT_ERROR,
	DELETE_ORGANISATION_CONTACT_ERROR,
	DELETE_ORGANISATION_CONTACT_SUCCESS,
	UPDATE_USER_PASSWORD_SUCCESS,
	UPDATE_USER_PASSWORD_ERROR,
	RESET_MY_EXPIRED_PASSWORD_FLAG,
	SERVER_UPDATE_USER_PASSWORD,
	SIGNOUT_USER,
	SERVER_UPDATE_ORGANISATION_SYSTEMROLES,
	UPDATE_ORGANISATION_SYSTEMROLES_SUCCESS,
	UPDATE_ORGANISATION_SYSTEMROLES_ERROR,
	UPDATE_ORGANISATION_DATA_SUCCESS,
	UPDATE_ORGANISATION_DATA_ERROR,
	ADD_ORGANISATION_USER_SUCCESS,
	ADD_ORGANISATION_USER_ERROR,
	ADD_ORGANISATION_GROUP_SUCCESS,
	ADD_ORGANISATION_GROUP_ERROR,
	ADD_ORGANISATION_USER,
	ADD_ORGANISATION_GROUP,
	SERVER_RESET_SHOW_INFO_MODAL_FLAG,
	UPDATE_GROUP_DATA_SUCCESS,
	UPDATE_GROUP_DATA_ERROR,
	UPDATE_ORGANISATION_DATA,
	SERVER_SET_USER_ACTIVE_STATUS,
	REMOVE_ORGANISATION_USER,
	REMOVE_ORGANISATION_USER_ERROR,
	SERVER_TRIGGER_USER_GROUP_ADMIN_STATUS,
	GET_GROUP_PROFILE_ERROR,
	GET_USER_PROFILE_ERROR,
	GET_ORGANISATION_PROFILE_ERROR,
	UPDATE_ORGANISATION_GROUP_STRUCTURE,
	SERVER_TRIGGER_CONNECTED_APP_USER_INTERNAL_TYPES,
	SERVER_UPDATE_CONNECTED_APP_USER_INTERNAL_TYPES,
	SERVER_CREATE_TYPE,
	RESET_CREATE_TYPE,
	UPDATE_ORGANISATION_PROFILE_TYPES_UPDATE,
	OPEN_INFO_MODAL
} from 'constants/ActionTypes';
import _ from 'lodash';

const INITIAL_STATE = {
	myUserProfile: {
		userId: null,
		firstName: null,
		lastName: null,
		userName: null,
		email: null,
		avatar: {
			image: null,
			initials: null,
			square: false
		},
		status: null,
		role: {
			roleId: null,
			name: null
		},
		replacementActive: false,
		assignmentOptions: {
			observeReportsAfterAssignmentRemoval: false,
			showFinalizedReports: false
		},
		deleteReportReasoningTemplates: [],
		chatTemplates: [],
		completeMessageTemplates: [],
		assignMessageTemplates: [],
		passwordExpired: false,
		showInfoModal: false,
		modules: {}
	},
	updateUserPasswordInvalidOldPassword: false,
	userProfile: {},
	userProfileAuth: {},
	groupProfile: {},
	groupProfileAuth: {},
	organisationProfile: {},
	organisationProfileAuth: {},
	citizenProfile: {},
	citizenProfileAuth: {},
	loading: {
		myUserProfile: true,
		userProfile: false,
		groupProfile: false,
		organisationProfile: false,
		citizenProfile: false,
		addUserToGroup: false,
		removeUserFromGroup: [],
		setUserGroupRole: [],
		updateOrganisationData: false,
		createNewUser: false,
		createNewGroup: false,
		saveOrganisationGroupStructure: false,
		updateGroupData: false,
		updateUserData: false,
		updateCitizenData: false,
		updateUserNotificationSettings: false,
		updateUserReplacements: false,
		updateUserAssignmentOptions: false,
		updateOrganisationResposibilities: false,
		updateOrganisationSettings: false,
		updateOrganisationMeldooAppSettings: false,
		updateOrganisationMeldooWebSettings: false,
		addAppUserConnection: false,
		removeAppUserConnection: [],
		updateUserSettings: false,
		updateGroupSettings: false,
		reportCitizen: false,
		addOrganisationContact: false,
		updateOrganisationContact: false,
		deleteOrganisationContact: [],
		updateUserPassword: false,
		updateOrganisationSystemroles: false,
		setUserActiveStatus: false,
		createType: false
	},
	errors: {
		organisationProfile: false,
		organisationProfilePermission: false,
		groupProfile: false,
		groupProfilePermission: false,
		userProfile: false,
		userProfilePermission: false,
		citizenProfile: false,
		citizenProfilePermission: false
	}
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case SIGNOUT_USER:
			return INITIAL_STATE;
		case SET_MY_USER_PROFILE:
			return {
				...state,
				myUserProfile: action.payload.userProfile,
				loading: { ...state.loading, myUserProfile: false }
			};
		case OPEN_INFO_MODAL:
			return {
				...state,
				myUserProfile: { ...state.myUserProfile, showInfoModal: true }
			};
		case SET_USER_PROFILE:
			return {
				...state,
				userProfile: action.payload.userProfile,
				userProfileAuth: action.payload.authorization,
				loading: { ...state.loading, userProfile: false }
			};
		case SET_GROUP_PROFILE:
			return {
				...state,
				groupProfile: action.payload.groupProfile,
				groupProfileAuth: action.payload.authorization,
				loading: { ...state.loading, groupProfile: false }
			};
		case SET_ORGANISATION_PROFILE:
			return {
				...state,
				organisationProfile: action.payload.organisationProfile,
				organisationProfileAuth: action.payload.authorization,
				loading: { ...state.loading, organisationProfile: false }
			};
		case SET_CITIZEN_PROFILE:
			return {
				...state,
				citizenProfile: action.payload.citizenProfile,
				citizenProfileAuth: action.payload.authorization,
				loading: { ...state.loading, citizenProfile: false }
			};
		case ADD_USER_TO_GROUP:
			return {
				...state,
				userProfile:
					state.userProfile.userId === action.payload.user.userId
						? {
								...state.userProfile,
								groups: [...state.userProfile.groups, action.payload.group]
						  }
						: state.userProfile,
				groupProfile:
					state.groupProfile.groupId === action.payload.group.groupId
						? {
								...state.groupProfile,
								users: [...state.groupProfile.users, action.payload.user]
						  }
						: state.groupProfile,
				loading: { ...state.loading, addUserToGroup: false }
			};
		case REMOVE_USER_FROM_GROUP:
			return {
				...state,
				userProfile:
					state.userProfile.userId === action.payload.userId
						? {
								...state.userProfile,
								groups: state.userProfile.groups.filter(group => group.groupId !== action.payload.groupId)
						  }
						: state.userProfile,
				groupProfile:
					state.groupProfile.groupId === action.payload.groupId
						? {
								...state.groupProfile,
								users: state.groupProfile.users.filter(user => user.userId !== action.payload.userId)
						  }
						: state.groupProfile,
				loading:
					state.userProfile.userId === action.payload.userId || state.groupProfile.groupId === action.payload.groupId
						? {
								...state.loading,
								removeUserFromGroup: state.loading.removeUserFromGroup.filter(
									value => value.userId !== action.payload.userId && value.groupId !== action.payload.groupId
								)
						  }
						: state.loading
			};
		case SET_USER_GROUP_ROLE:
			return {
				...state,
				userProfile:
					state.userProfile.userId === action.payload.userId
						? {
								...state.userProfile,
								groups: state.userProfile.groups.map(group =>
									group.groupId === action.payload.groupId
										? {
												...group,
												role: action.payload.role
										  }
										: group
								)
						  }
						: state.userProfile,
				groupProfile:
					state.groupProfile.groupId === action.payload.groupId
						? {
								...state.groupProfile,
								users: state.groupProfile.users.map(user =>
									user.userId === action.payload.userId
										? {
												...user,
												groupRole: action.payload.role
										  }
										: user
								)
						  }
						: state.groupProfile,
				loading:
					state.userProfile.userId === action.payload.userId || state.groupProfile.groupId === action.payload.groupId
						? {
								...state.loading,
								setUserGroupRole: state.loading.setUserGroupRole.filter(
									value => value.userId !== action.payload.userId && value.groupId !== action.payload.groupId
								)
						  }
						: state.loading
			};
		case UPDATE_USER_REPLACEMENTS:
			return {
				...state,
				userProfile: {
					...state.userProfile,
					replacements: state.userProfile.userId === action.payload.userId ? action.payload.replacements : state.userProfile.replacements
				},
				myUserProfile:
					state.myUserProfile.userId === action.payload.userId
						? {
								...state.myUserProfile,
								replacementActive: action.payload.replacements.length !== 0
						  }
						: state.myUserProfile
			};
		case UPDATE_USER_DATA:
			return {
				...state,
				userProfile:
					state.userProfile.userId === action.payload.userId ? { ...state.userProfile, ...action.payload.updateData } : state.userProfile
			};
		case UPDATE_USER_NOTIFICATION_SETTINGS:
			return {
				...state,
				userProfile: {
					...state.userProfile,
					notificationSettings:
						state.userProfile.userId === action.payload.userId
							? action.payload.notificationSettings
							: state.userProfile.notificationSettings
				}
			};
		case UPDATE_USER_ASSIGNMENT_OPTIONS:
			return {
				...state,
				userProfile: {
					...state.userProfile,
					assignmentOptions:
						state.userProfile.userId === action.payload.userId ? action.payload.assignmentOptions : state.userProfile.assignmentOptions
				},
				myUserProfile:
					state.myUserProfile.userId === action.payload.userId
						? {
								...state.myUserProfile,
								assignmentOptions: action.payload.assignmentOptions
						  }
						: state.myUserProfile
			};
		case UPDATE_ORGANISATION_APP_USER_CONNECTIONS:
			return {
				...state,
				organisationProfile:
					state.organisationProfile.organisationId === action.payload.organisationId
						? {
								...state.organisationProfile,
								meldooAppSettings: {
									...state.organisationProfile.meldooAppSettings,
									connectedAppUsers: action.payload.connectedAppUsers
								}
						  }
						: state.organisationProfile,
				loading: {
					...state.loading,
					addAppUserConnection: false,
					removeAppUserConnection: _.compact(
						state.loading.removeAppUserConnection.map(citizenId =>
							_.find(action.payload.connectedAppUsers, {
								citizenId
							})
								? citizenId
								: null
						)
					)
				}
			};
		case UPDATE_USER_SETTINGS:
			return {
				...state,
				userProfile: {
					...state.userProfile,
					replacements: action.payload.replacements ? action.payload.replacements : state.userProfile.replacements,
					notificationSettings: action.payload.notificationSettings
						? action.payload.notificationSettings
						: state.userProfile.notificationSettings,
					assignmentOptions: action.payload.assignmentOptions ? action.payload.assignmentOptions : state.userProfile.notificationSettings
				},
				myUserProfile:
					action.payload.userId === state.myUserProfile.userId
						? {
								...state.myUserProfile,
								replacementActive:
									action.payload.replacements &&
									Array.isArray(action.payload.replacements) &&
									action.payload.replacements.length > 0
										? true
										: false,
								chatTemplates:
									action.payload.chatTemplates && Array.isArray(action.payload.chatTemplates) ? action.payload.chatTemplates : [],
								deleteReportReasoningTemplates:
									action.payload.deleteReportReasoningTemplates && Array.isArray(action.payload.deleteReportReasoningTemplates)
										? action.payload.deleteReportReasoningTemplates
										: [],
								completeMessageTemplates:
									action.payload.completeMessageTemplates && Array.isArray(action.payload.completeMessageTemplates)
										? action.payload.completeMessageTemplates
										: [],
								assignMessageTemplates:
									action.payload.assignMessageTemplates && Array.isArray(action.payload.assignMessageTemplates)
										? action.payload.assignMessageTemplates
										: []
						  }
						: state.myUserProfile,
				loading: { ...state.loading, updateUserSettings: false }
			};
		case UPDATE_GROUP_SETTINGS:
			return {
				...state,
				groupProfile: {
					...state.groupProfile,
					openTimeSettings: action.payload.openTimeSettings
						? {
								individualOpenTime: action.payload.openTimeSettings.individualOpenTime,
								openTime: action.payload.openTimeSettings.openTime || state.groupProfile.openTimeSettings.openTime
						  }
						: state.groupProfile.openTimeSettings
				},
				loading: { ...state.loading, openTimeSettings: false }
			};
		case UPDATE_ORGANISATION_CONTACTS:
			return {
				...state,
				organisationProfile: {
					...state.organisationProfile,
					contacts: action.payload.contacts
				},
				loading: {
					...state.loading,
					addOrganisationContact: false,
					updateOrganisationContact: false
				}
			};
		case ADD_ORGANISATION_USER:
			return {
				...state,
				organisationProfile: {
					...state.organisationProfile,
					users:
						state.organisationProfile.organisationId === action.payload.organisationId
							? [...state.organisationProfile.users, action.payload.newUser]
							: state.organisationProfile.users
				}
			};
		case ADD_ORGANISATION_GROUP:
			return {
				...state,
				organisationProfile: {
					...state.organisationProfile,
					groups:
						state.organisationProfile.organisationId === action.payload.organisationId
							? [...state.organisationProfile.groups, action.payload.newGroup]
							: state.organisationProfile.groups
				}
			};
		case UPDATE_ORGANISATION_DATA:
			return {
				...state,
				organisationProfile:
					action.payload.organisationId === state.organisationProfile.organisationId
						? {
								...state.organisationProfile,
								...action.payload.updatedData
						  }
						: state.organisationProfile
			};
		case SERVER_GET_USER_PROFILE:
			return {
				...state,
				userProfile: {},
				userProfileAuth: {},
				loading: { ...state.loading, userProfile: true },
				errors: { ...state.errors, userProfile: false, userProfilePermission: false }
			};
		case SERVER_GET_GROUP_PROFILE:
			return {
				...state,
				groupProfile: {},
				groupProfileAuth: {},
				loading: { ...state.loading, groupProfile: true },
				errors: { ...state.errors, groupProfile: false, groupProfilePermission: false }
			};
		case SERVER_GET_ORGANISATION_PROFILE:
			return {
				...state,
				organisationProfile: {},
				organisationProfileAuth: {},
				loading: { ...state.loading, organisationProfile: true },
				errors: { ...state.errors, organisationProfile: false, organisationProfilePermission: false }
			};
		case SERVER_GET_CITIZEN_PROFILE:
			return {
				...state,
				loading: { ...state.loading, citizenProfile: true }
			};
		case SERVER_ADD_USER_TO_GROUP:
			return {
				...state,
				loading: { ...state.loading, addUserToGroup: true }
			};
		case SERVER_REMOVE_USER_FROM_GROUP:
			return {
				...state,
				loading: {
					...state.loading,
					removeUserFromGroup: [
						...state.loading.removeUserFromGroup,
						{
							userId: action.payload.userId,
							groupId: action.payload.groupId
						}
					]
				}
			};
		case SERVER_SET_USER_GROUP_ROLE:
			return {
				...state,
				loading: {
					...state.loading,
					setUserGroupRole: [
						...state.loading.setUserGroupRole,
						{
							userId: action.payload.userId,
							groupId: action.payload.groupId
						}
					]
				}
			};
		case SERVER_UPDATE_ORGANISATION_DATA:
			return {
				...state,
				loading: { ...state.loading, updateOrganisationData: true }
			};
		case SERVER_UPDATE_ORGANISATION_GROUP_STRUCTURE:
			return {
				...state,
				loading: {
					...state.loading,
					saveOrganisationGroupStructure: true
				}
			};
		case SERVER_CREATE_NEW_GROUP:
			return {
				...state,
				loading: { ...state.loading, createNewGroup: true }
			};
		case SERVER_CREATE_NEW_USER:
			return {
				...state,
				loading: { ...state.loading, createNewUser: true }
			};
		case SERVER_UPDATE_GROUP_DATA:
			return {
				...state,
				loading: { ...state.loading, updateGroupData: true }
			};
		case SERVER_UPDATE_USER_DATA:
			return {
				...state,
				loading: { ...state.loading, updateUserData: true }
			};
		case SERVER_UPDATE_CITIZEN_DATA:
			return {
				...state,
				loading: { ...state.loading, updateCitizenData: true }
			};
		case SERVER_UPDATE_USER_REPLACEMENTS:
			return {
				...state,
				loading: { ...state.loading, updateUserReplacements: true }
			};
		case SERVER_UPDATE_USER_NOTIFICATION_SETTINGS:
			return {
				...state,
				loading: {
					...state.loading,
					updateUserNotificationSettings: true
				}
			};
		case SERVER_UPDATE_USER_ASSIGNMENT_OPTIONS:
			return {
				...state,
				loading: { ...state.loading, updateUserAssignmentOptions: true }
			};
		case SERVER_UPDATE_ORGANISATION_RESPONSIBILITIES:
			return {
				...state,
				loading: {
					...state.loading,
					updateOrganisationResposibilities: true
				}
			};
		case SERVER_UPDATE_ORGANISATION_SETTINGS:
			return {
				...state,
				loading: {
					...state.loading,
					updateOrganisationSettings: true
				}
			};
		case SERVER_UPDATE_ORGANISATION_MELDOO_APP_SETTINGS:
			return {
				...state,
				loading: {
					...state.loading,
					updateOrganisationMeldooAppSettings: true
				}
			};
		case SERVER_UPDATE_ORGANISATION_MELDOO_WEB_SETTINGS:
			return {
				...state,
				loading: {
					...state.loading,
					updateOrganisationMeldooWebSettings: true
				}
			};
		case SERVER_ADD_ORGANISATION_APP_USER_CONNECTION:
			return {
				...state,
				loading: {
					...state.loading,
					addAppUserConnection: true
				}
			};
		case SERVER_REMOVE_ORGANISATION_APP_USER_CONNECTION:
			return {
				...state,
				loading: {
					...state.loading,
					removeAppUserConnection: [...state.loading.removeAppUserConnection, action.payload.citizenId]
				}
			};
		case SERVER_UPDATE_USER_SETTINGS:
			return {
				...state,
				loading: { ...state.loading, updateUserSettings: true }
			};
		case SERVER_UPDATE_GROUP_SETTINGS:
			return {
				...state,
				loading: { ...state.loading, updateGroupSettings: true }
			};
		case SERVER_REPORT_CITIZEN:
			return {
				...state,
				loading: { ...state.loading, reportCitizen: true }
			};
		case SERVER_ADD_ORGANISATION_CONTACT:
			return {
				...state,
				loading: {
					...state.loading,
					addOrganisationContact: true
				}
			};
		case SERVER_UPDATE_ORGANISATION_CONTACT:
			return {
				...state,
				loading: {
					...state.loading,
					updateOrganisationContact: true
				}
			};
		case SERVER_DELETE_ORGANISATION_CONTACT:
			return {
				...state,
				loading: {
					...state.loading,
					deleteOrganisationContact: [...state.loading.deleteOrganisationContact, action.payload.contactId]
				}
			};
		case SERVER_UPDATE_USER_PASSWORD:
			return {
				...state,
				updateUserPasswordInvalidOldPassword: false,
				loading: {
					...state.loading,
					updateUserPassword: true
				}
			};
		case SERVER_UPDATE_ORGANISATION_SYSTEMROLES:
			return {
				...state,
				loading: {
					...state.loading,
					updateOrganisationSystemroles: true
				},
				organisationProfile: {
					...state.organisationProfile,
					organisationRoles: action.payload.systemroles
				}
			};
		case SERVER_RESET_SHOW_INFO_MODAL_FLAG:
			return {
				...state,
				myUserProfile: {
					...state.myUserProfile,
					showInfoModal: false
				}
			};
		case SERVER_TRIGGER_CONNECTED_APP_USER_INTERNAL_TYPES:
			return {
				...state,
				organisationProfile: {
					...state.organisationProfile,
					meldooAppSettings: {
						...state.organisationProfile.meldooAppSettings,
						connectedAppUsers: state.organisationProfile.meldooAppSettings.connectedAppUsers.map(u =>
							u.idConnectedAppUsers === action.payload.idConnectedAppUsers
								? { ...u, showInternalTypes: action.payload.value, internalTypes: [] }
								: u
						)
					}
				}
			};
		case SERVER_UPDATE_CONNECTED_APP_USER_INTERNAL_TYPES:
			return {
				...state,
				organisationProfile: {
					...state.organisationProfile,
					meldooAppSettings: {
						...state.organisationProfile.meldooAppSettings,
						connectedAppUsers: state.organisationProfile.meldooAppSettings.connectedAppUsers.map(u =>
							u.idConnectedAppUsers === action.payload.idConnectedAppUsers
								? { ...u, internalTypes: action.payload.selectedInternalTypes }
								: u
						)
					}
				}
			};
		case UPDATE_USER_PASSWORD_SUCCESS:
			return {
				...state,
				updateUserPasswordInvalidOldPassword: false,
				loading: {
					...state.loading,
					updateUserPassword: false
				}
			};
		case UPDATE_USER_PASSWORD_ERROR:
			return {
				...state,
				updateUserPasswordInvalidOldPassword: action.payload.error === 'oldPasswordInvalid',
				loading: {
					...state.loading,
					updateUserPassword: false
				}
			};
		case RESET_MY_EXPIRED_PASSWORD_FLAG:
			return {
				...state,
				myUserProfile: {
					...state.myUserProfile,
					passwordExpired: false
				}
			};
		case ADD_ORGANISATION_CONTACT_ERROR:
			return {
				...state,
				loading: {
					...state.loading,
					addOrganisationContact: false
				}
			};
		case UPDATE_ORGANISATION_CONTACT_ERROR:
			return {
				...state,
				loading: {
					...state.loading,
					updateOrganisationContact: false
				}
			};
		case DELETE_ORGANISATION_CONTACT_SUCCESS:
		case DELETE_ORGANISATION_CONTACT_ERROR:
			return {
				...state,
				loading: {
					...state.loading,
					deleteOrganisationContact: state.loading.deleteOrganisationContact.filter(contactId => contactId !== action.payload.contactId)
				}
			};
		case REPORT_CITIZEN_SUCCESS:
		case REPORT_CITIZEN_ERROR:
			return {
				...state,
				loading: { ...state.loading, reportCitizen: false }
			};
		case UPDATE_ORGANISATION_RESPONSIBILITIES_SUCCESS:
		case UPDATE_ORGANISATION_RESPONSIBILITIES_ERROR:
			return {
				...state,
				loading: {
					...state.loading,
					updateOrganisationResposibilities: false
				}
			};
		case UPDATE_USER_DATA_SUCCESS:
		case UPDATE_USER_DATA_ERROR:
			return {
				...state,
				loading: { ...state.loading, updateUserData: false }
			};
		case UPDATE_USER_REPLACEMENTS_SUCCESS:
		case UPDATE_USER_REPLACEMENTS_ERROR:
			return {
				...state,
				loading: { ...state.loading, updateUserReplacements: false }
			};
		case UPDATE_USER_NOTIFICATION_SETTINGS_SUCCESS:
		case UPDATE_USER_NOTIFICATION_SETTINGS_ERROR:
			return {
				...state,
				loading: {
					...state.loading,
					updateUserNotificationSettings: false
				}
			};
		case UPDATE_USER_ASSIGNMENT_OPTIONS_SUCCESS:
		case UPDATE_USER_ASSIGNMENT_OPTIONS_ERROR:
			return {
				...state,
				loading: {
					...state.loading,
					updateUserAssignmentOptions: false
				}
			};
		case UPDATE_ORGANISATION_SETTINGS_SUCCESS:
		case UPDATE_ORGANISATION_SETTINGS_ERROR:
			return {
				...state,
				loading: {
					...state.loading,
					updateOrganisationSettings: false
				}
			};
		case UPDATE_ORGANISATION_MELDOO_APP_SETTINGS_SUCCESS:
		case UPDATE_ORGANISATION_MELDOO_APP_SETTINGS_ERROR:
			return {
				...state,
				loading: {
					...state.loading,
					updateOrganisationMeldooAppSettings: false
				}
			};
		case UPDATE_ORGANISATION_MELDOO_WEB_SETTINGS_SUCCESS:
		case UPDATE_ORGANISATION_MELDOO_WEB_SETTINGS_ERROR:
			return {
				...state,
				loading: {
					...state.loading,
					updateOrganisationMeldooWebSettings: false
				}
			};
		case ADD_ORGANISATION_APP_USER_CONNECTION_SUCCESS:
		case ADD_ORGANISATION_APP_USER_CONNECTION_ERROR:
			return {
				...state,
				loading: { ...state.loading, addAppUserConnection: false }
			};
		case UPDATE_ORGANISATION_SYSTEMROLES_SUCCESS:
		case UPDATE_ORGANISATION_SYSTEMROLES_ERROR:
			return {
				...state,
				loading: { ...state.loading, updateOrganisationSystemroles: false }
			};
		case REMOVE_ORGANISATION_APP_USER_CONNECTION_ERROR:
			return {
				...state,
				loading: { ...state.loading, removeAppUserConnection: [] }
			};
		case UPDATE_ORGANISATION_DATA_SUCCESS:
		case UPDATE_ORGANISATION_DATA_ERROR:
			return {
				...state,
				loading: { ...state.loading, updateOrganisationData: false }
			};
		case ADD_ORGANISATION_GROUP_SUCCESS:
		case ADD_ORGANISATION_GROUP_ERROR:
			return {
				...state,
				loading: { ...state.loading, createNewGroup: false }
			};
		case ADD_ORGANISATION_USER_SUCCESS:
		case ADD_ORGANISATION_USER_ERROR:
			return {
				...state,
				loading: { ...state.loading, createNewUser: false }
			};
		case UPDATE_GROUP_DATA_SUCCESS:
		case UPDATE_GROUP_DATA_ERROR:
			return {
				...state,
				loading: { ...state.loading, updateGroupData: false }
			};
		case SERVER_SET_USER_ACTIVE_STATUS:
			return {
				...state,
				loading: { ...state.loading, setUserActiveStatus: true }
			};
		case REMOVE_ORGANISATION_USER:
			return {
				...state,
				organisationProfile: {
					...state.organisationProfile,
					users: state.organisationProfile.users.filter(u => u.userId !== action.payload.userId)
				},
				loading: { ...state.loading, setUserActiveStatus: false }
			};
		case REMOVE_ORGANISATION_USER_ERROR:
			return { ...state, loading: { ...state.loading, setUserActiveStatus: false } };
		case SERVER_TRIGGER_USER_GROUP_ADMIN_STATUS:
			return {
				...state,
				groupProfile:
					state.groupProfile.groupId === action.payload.groupId
						? {
								...state.groupProfile,
								users: state.groupProfile.users.map(u =>
									u.userId === action.payload.userId ? { ...u, isGroupAdmin: action.payload.status } : u
								)
						  }
						: state.groupProfile,
				userProfile:
					state.userProfile.userId === action.payload.userId
						? {
								...state.userProfile,
								groups: state.userProfile.groups.map(g =>
									g.groupId === action.payload.groupId ? { ...g, isGroupAdmin: action.payload.status } : g
								)
						  }
						: state.userProfile
			};
		case GET_GROUP_PROFILE_ERROR:
			return {
				...state,
				loading: { ...state.loading, groupProfile: false },
				errors: { ...state.errors, groupProfile: true, groupProfilePermission: action.payload.permissionError }
			};
		case GET_USER_PROFILE_ERROR:
			return {
				...state,
				loading: { ...state.loading, userProfile: false },
				errors: { ...state.errors, userProfile: true, userProfilePermission: action.payload.permissionError }
			};
		case GET_ORGANISATION_PROFILE_ERROR:
			return {
				...state,
				loading: { ...state.loading, organisationProfile: false },
				errors: { ...state.errors, organisationProfile: true, organisationProfilePermission: action.payload.permissionError }
			};
		case UPDATE_ORGANISATION_GROUP_STRUCTURE:
			return {
				...state,
				loading: {
					...state.loading,
					saveOrganisationGroupStructure: false
				}
			};
		case SERVER_CREATE_TYPE:
			return {
				...state,
				loading: {
					...state.loading,
					createType: true
				}
			};
		case RESET_CREATE_TYPE:
			return {
				...state,
				loading: { ...state.loading, createType: false }
			};
		case UPDATE_ORGANISATION_PROFILE_TYPES_UPDATE:
			return {
				...state,
				organisationProfile:
					action.payload.organisationId === state.organisationProfile.organisationId
						? {
								...state.organisationProfile,
								meldooAppSettings: {
									...state.organisationProfile.meldooAppSettings,
									connectedAppUsers: action.payload.connectedAppUsers,
									internalTypes: action.payload.internalTypes
								},
								organisationTypesResponsibles: action.payload.organisationTypesResponsibles,
								organisationTypesResponsiblesTimestamp: new Date().getTime(),
								deadlineSettings: action.payload.deadlineSettings,
								defaultChatMessageSettings: action.payload.defaultChatMessageSettings,
								prioritySettings: action.payload.prioritySettings
						  }
						: state.organisationProfile
			};
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./reducers/Profile.js